import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveCalendarExportLinksRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveCalendarExportLinksRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveCalendarExportLinksRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getCalendarExportLinks() {
      return getState().links;
    },
  };
}

export { createSelector };
